var _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    viewBox: "0 0 36 35",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6434,
    cy: 17.5,
    fill: "#801ed7",
    rx: 17.6434,
    ry: 17.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.6919 5.32469c-6.6717 0-12.0803 5.40851-12.0803 12.08031s5.4086 12.0804 12.0803 12.0804c6.6718 0 12.0804-5.4086 12.0804-12.0804s-5.4086-12.08031-12.0804-12.08031zm-14.53614 12.08031c0-8.02808 6.50807-14.53615 14.53614-14.53615 8.0282 0 14.5362 6.50807 14.5362 14.53615 0 8.0281-6.508 14.5362-14.5362 14.5362-8.02807 0-14.53614-6.5081-14.53614-14.5362z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.7692 26.4679c2.5469-.2828 4.0925-2.627 4.7477-3.8382.6433-1.2208 1.0093-2.5232 1.1558-3.7868.0515-.3826.08-.7217.088-1.037.0261-1.0092-.1276-1.8728-.469-2.642-.7407-1.666-2.0439-2.539-3.8739-2.5945-.9039-.0277-1.7983.1719-2.5977.576.1965-.7772.7582-3.0952 1.0663-5.3696.0476-.34936-.0467-.68446-.2638-.94351-.2154-.25826-.5268-.40799-.8761-.42304-.6473-.02931-1.1923.43334-1.2755 1.07265-.4642 3.5879-1.5694 8.2263-2.7497 11.5424-.6132 1.7231-1.7706 3.1475-3.3463 4.1187-.0563.0349-.1363.0776-.2369.1283-.5775.2908-.84527.9634-.62187 1.5639.12359.3327.38343.5989.71377.7312.3304.1315.7019.118 1.0204-.0381.9847-.4816 1.8569-1.1201 2.5937-1.8981.915 1.9774 2.4407 3.1126 4.9243 2.8369zm-2.0201-3.0864c-.4381-.4247-.6988-.9919-.7748-1.6843-.2123-1.9187.3533-3.6869 1.6819-5.2555.3422-.404.7367-.7288 1.1724-.9649.3858-.2091.7946-.3097 1.1875-.3097.694 0 1.3373.3145 1.7104.8991.2979.4666.4603 1.0236.4959 1.7017.0135.2606.0064.5268 0 .7407-.0024.08-.0039.1537-.0047.2163-.2615 1.7983-.9253 3.1585-2.0899 4.2819-.423.4079-.8595.6765-1.3348.8191-.8144.2456-1.4838.0998-2.0439-.4444z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazeLogo);
export default __webpack_public_path__ + "static/media/braze-logo.8dfc3ba3c48c949950cfe85b38377d2d.svg";
export { ForwardRef as ReactComponent };